import { ReactComponent as AthenaIcon } from '../assets/data-warehouses/athena.svg';
import { ReactComponent as BigQueryIcon } from '../assets/data-warehouses/bigquery.svg';
import { ReactComponent as ClickhouseIcon } from '../assets/data-warehouses/clickhouse.svg';
import { ReactComponent as DatabricksIcon } from '../assets/data-warehouses/databricks.svg';
import { ReactComponent as DefaultIcon } from '../assets/data-warehouses/default.svg';
import { ReactComponent as PostgresIcon } from '../assets/data-warehouses/postgres.svg';
import { ReactComponent as RedshiftIcon } from '../assets/data-warehouses/redshift.svg';
import { ReactComponent as SnowflakeIcon } from '../assets/data-warehouses/snowflake.svg';
import { ReactComponent as TrinoIcon } from '../assets/data-warehouses/trino.svg';
import { ReactComponent as DremioIcon } from '../assets/data-warehouses/dremio.svg';
import { ReactComponent as FabricIcon } from '../assets/data-warehouses/fabric.svg';

const warehouseTypeIconMap: Record<string, React.FC> = {
  postgres: PostgresIcon,
  redshift: RedshiftIcon,
  snowflake: SnowflakeIcon,
  bigquery: BigQueryIcon,
  databricks: DatabricksIcon,
  athena: AthenaIcon,
  clickhouse: ClickhouseIcon,
  trino: TrinoIcon,
  dremio: DremioIcon,
  fabric: FabricIcon,
};

export const getWarehouseIcon = (warehouseType: string): React.FC =>
  warehouseTypeIconMap?.[warehouseType] || DefaultIcon;
